<template>
    <div :class="[$prefixClass.card + '-stroke', 'error-box']">
        <p v-html="error"></p>
    </div>
</template>
<script>
export default {
    name: 'ErrorBox',
    props: {
        error: {
            type: String,
            required: true
        }
    }
}
</script>
<style lang="scss">
    .error-box {
        padding: 14px;
        color: $danger-color;
        border-color: $danger-color !important;
        background: #ffe0e0 !important;
        p {
            max-width: 370px;
            margin-bottom: 0;
        }
    }
</style>